module.exports = __webpack_public_path__ + "img/ic-cubo-origen.cae3cfe3.svg";